<planning-top-nav></planning-top-nav>

<div class="projects-container">
  <!-- Loading -->
  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner"></div>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <!-- Header -->
  <div class="header" *ngIf="!isLoading">
    <h2>Projects</h2>
    <div class="header-actions">
      <button class="btn btn-primary" (click)="openCreateModal()">
        + New Project
      </button>
    </div>
  </div>

  <!-- Sticky Pagination -->
  <div class="pagination sticky" *ngIf="!isLoading">
    <div class="page-controls">
      <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">
        Prev
      </button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
        Next
      </button>
    </div>

    <div class="page-size">
      <label for="pageSize">Page Size:</label>
      <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize(pageSize)">
        <option *ngFor="let size of pageSizes" [value]="size">
          {{ size }}
        </option>
      </select>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters-container" *ngIf="!isLoading">
    <div class="filters-row">
      <label class="filter-field search-field">
        <span>Search</span>
        <app-search-bar
          [value]="filters.searchTerm"
          [debounceMs]="1000"
          placeholder="Search project name"
          (searchChange)="onSearchTermChange($event)">
        </app-search-bar>
      </label>
    </div>
  </div>

  <!-- Projects List -->
  <div class="projects-list">
    <div
      *ngFor="let project of projects$ | async; trackBy: trackByProjectId"
      class="project-card"
      [class.expanded]="isProjectExpanded(project.id)"
    >
      <!-- Project Row -->
      <div class="project-row" (click)="toggleProject(project)">
        <div class="project-info">
          <div class="project-name-row">
            <div class="project-name">
              {{ project.name }}
            </div>

            <div class="expand-indicator" [class.open]="isProjectExpanded(project.id)">
              ▾
            </div>
          </div>

          <div class="project-meta">
            <span class="description">
              {{ project.description || 'No description' }}
            </span>
          </div>
        </div>

        <div class="project-actions">
          <button
            class="btn edit"
            (click)="openEditModal(project); $event.stopPropagation()"
          >
            Edit
          </button>
        </div>
      </div>

      <!-- Expanded Detail -->
      <div class="project-expand-panel" *ngIf="isProjectExpanded(project.id)">
        
        <!-- Loading -->
        <div *ngIf="isProjectDetailLoading(project.id)" class="project-inline-loading">
          <div class="mini-spinner"></div>
          <span>Loading work orders...</span>
        </div>

        <!-- Loaded -->
        <ng-container
          *ngIf="
            !isProjectDetailLoading(project.id) &&
            expandedProjectDetail &&
            expandedProjectId === project.id
          "
        >
          <div class="project-expand-header">
            <div class="title">Work Orders</div>
            <div class="sub">
              {{ expandedProjectDetail.workOrderNumbers.length || 0 }} total
            </div>
          </div>

          <!-- Work Orders -->
          <div
            *ngIf="
              (expandedProjectDetail.workOrderNumbers.length || 0) > 0;
              else noWorkOrders
            "
            class="work-orders-nested-list"
          >
            <div
              *ngFor="
                let wo of expandedProjectDetail.workOrderNumbers;
                trackBy: trackByWorkOrderId
              "
              class="nested-work-order-row"
            >
              <div class="nested-top-row">
                <div class="work-order-won">{{ wo.won }}</div>

                <div
                  class="status-badge"
                  [class.active]="wo.isActive"
                  [class.inactive]="!wo.isActive"
                >
                  {{ wo.isActive ? 'Active' : 'Inactive' }}
                </div>
              </div>

              <div class="work-order-meta">
                <span>Dept: {{ wo.department.code }}</span>
              </div>

              <div class="work-order-description" *ngIf="wo.description">
                {{ wo.description }}
              </div>
            </div>
          </div>

          <!-- Empty -->
          <ng-template #noWorkOrders>
            <div class="empty-work-orders">
              No work orders found for this project.
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Create / Edit Modal -->
  <div *ngIf="modalOpen" class="modal-backdrop">
    <div class="modal" (click)="$event.stopPropagation()">
      <h2>{{ isEditMode ? 'Edit Project' : 'New Project' }}</h2>

      <form #projectForm="ngForm" (ngSubmit)="submitProject(projectForm)">
        <label>Project Name</label>
        <input type="text" name="name" [(ngModel)]="formModel.name" required />

        <label>Description</label>
        <textarea name="description" [(ngModel)]="formModel.description"></textarea>

        <div class="modal-buttons">
          <button type="button" class="btn btn-secondary" (click)="closeModal()">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary">
            {{ isEditMode ? 'Update' : 'Create' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Toast -->
  <div *ngIf="toastVisible" class="toast" [ngClass]="toastType">
    <img class="icon" alt="icon" />
    <span>{{ toastMessage }}</span>
  </div>
</div>